// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"a9bf80ac","453":"61a7f79d","766":"60ff2c8c","803":"100e0eb8"}[chunkId] + ".chunk.js";
};